import { CustomerDto } from '@groundfloor-platform/mgmt-service-g-sdk';

/** The customer an order will be booked for: found by search, or the new-customer form. */
export type SelectedCustomer = { isExisting: true; customer: CustomerDto } | { isExisting: false };

/** Promotes a customer created during booking to an existing one, so "book another" reuses them. */
export function foldInCreatedCustomer(
  selectedCustomer: SelectedCustomer,
  searchResults: CustomerDto[],
  createdCustomer: CustomerDto | undefined
): { selectedCustomer: SelectedCustomer; searchResults: CustomerDto[] } {
  if (!createdCustomer) {
    return { selectedCustomer, searchResults };
  }
  return {
    selectedCustomer: { isExisting: true, customer: createdCustomer },
    searchResults: searchResults.some(({ id }) => id === createdCustomer.id)
      ? searchResults
      : [...searchResults, createdCustomer]
  };
}
